import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, resolveBackendAssetUrl } from "../../lib/api";
import { Bell } from "lucide-react";

export default function Avisos() {
  const [alerts, setAlerts] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    api.get("/alerts/active")
      .then((r) => {
        const active = r.data || [];
        if (active.length === 0) {
          navigate("/", { replace: true });
          return;
        }
        setAlerts(active);
      })
      .catch(() => navigate("/", { replace: true }))
      .finally(() => setLoading(false));
  }, [navigate]);

  return (
    <div className="space-y-6 animate-in fade-in duration-500 -mx-4 sm:mx-0" data-testid="avisos-page">
      <header className="px-4 sm:px-0 pt-2 pb-1">
        <div className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.25em] text-primary font-bold">
          <Bell size={15} strokeWidth={2.5} />
          Hoy
        </div>
        <h1 className="font-display font-black text-4xl sm:text-5xl mt-2 leading-none">
          Hoy en Casa del Pueblo
        </h1>
        <p className="text-muted-foreground mt-3 text-base sm:text-lg">
          Ofertas, platos destacados y novedades del día.
        </p>
      </header>

      {loading ? (
        <div className="px-4 sm:px-0 py-8 text-muted-foreground">Cargando...</div>
      ) : (
        <ul className="space-y-4 px-4 sm:px-0" data-testid="avisos-list">
          {alerts.map((a) => (
            <li
              key={a.id}
              className="overflow-hidden rounded-2xl border border-primary/20 bg-white shadow-sm"
              data-testid={`aviso-${a.id}`}
            >
              {a.image_url && (
                <div className="bg-accent">
                  <img
                    src={resolveBackendAssetUrl(a.image_url, a.created_at)}
                    alt={a.title}
                    className="h-auto max-h-[360px] w-full object-contain"
                  />
                </div>
              )}

              <article className="p-5 sm:p-6">
                <div className="flex items-start gap-3">
                  <Bell size={18} className="mt-1 shrink-0 text-primary" />
                  <div className="min-w-0">
                    <h2 className="font-display font-black text-2xl sm:text-3xl leading-tight">
                      {a.title}
                    </h2>
                    <p className="mt-3 whitespace-pre-line text-base leading-relaxed text-foreground/90">
                      {a.message}
                    </p>
                    {a.created_at && (
                      <time
                        dateTime={a.created_at}
                        className="mt-4 block text-[11px] uppercase tracking-widest text-muted-foreground"
                      >
                        {new Date(a.created_at).toLocaleString("es-ES", {
                          day: "2-digit",
                          month: "short",
                          hour: "2-digit",
                          minute: "2-digit",
                        })}
                      </time>
                    )}
                  </div>
                </div>
              </article>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
